<script setup lang="ts">
import SelectOutputTime from "@/components/Every24HoursReportPreviewParts/SelectOutputTime.vue";
import TableHeader from "@/components/Every24HoursReportPreviewParts/TableHeader.vue";
import TableRow from "@/components/Every24HoursReportPreviewParts/TableRow.vue";
import every24HoursPreviewType from "@/types/responses/every24HoursPreview";
import { computed } from "vue";
import {
  CHART_DETAIL_TABLE_HEADERS,
  CHART_DETAIL_TABLE_ROWS,
} from "@/services/consts/every_24_hours_report";

const emit = defineEmits(['update:modelValue']);

const props = defineProps<{
  modelValue: string
  index: number
  deliveryPlan: every24HoursPreviewType
  downloading: boolean
  chartDetails:{
    deliveryPlanDate: string,
    displayStartTime: string,
    drivingDistance: string,
    drivingTime: string
  }
}>()

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})
</script>
<template>
  <div
    class="mt-3 mx-auto col-12 bg-grey-lighten-1"
    style="width: 85%"
  >
    <div
      class="d-flex px-6 py-3"
    >
      <v-table
        class="col-7"
        density="compact"
      >
        <TableHeader
          :headers="CHART_DETAIL_TABLE_HEADERS"
        />
        <TableRow
          :deliveryPlan="props.deliveryPlan"
          :index="props.index"
          :rowItems="CHART_DETAIL_TABLE_ROWS"
          :chartDetails="props.chartDetails"
        />
      </v-table>
      <SelectOutputTime
        v-model="modelValue"
        :index="props.index"
        :downloading="props.downloading"
      />
    </div>
  </div>
</template>
